module.exports = "/images/vendor/flag-icon-css/flags/4x3/nr.svg?d16edc69065bf2bd0b0ba47650201d6b";